import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Card } from 'primereact/card';
import { Dropdown } from 'primereact/dropdown';
import { Button } from 'primereact/button';
import {
    fetchCompanyData,
    setSelectedClient,
    setSelectedBranch,
    setSelectedPlatform,
    resetFilters,
    selectClients,
    selectSelectedClient,
    selectSelectedBranch,
    selectSelectedPlatform,
    selectFilteredBranches,
    selectFilteredPlatforms,
    selectLoading
} from '../store/slices/companySlice';
import './CategoryMaster.css';

const CompanyHeader = () => {
    const dispatch = useDispatch();
    const role = localStorage.getItem('role') || '';
    const isGspos = role.toUpperCase() === 'GSPOS';
    const clients = useSelector(selectClients);
    const selectedClient = useSelector(selectSelectedClient);
    const selectedBranch = useSelector(selectSelectedBranch);
    const selectedPlatform = useSelector(selectSelectedPlatform);
    const filteredBranches = useSelector(selectFilteredBranches);
    const filteredPlatforms = useSelector(selectFilteredPlatforms);
    const loading = useSelector(selectLoading);

    useEffect(() => {
        dispatch(
            fetchCompanyData({
                rolename: role,
                clientname: localStorage.getItem('clientid') || ''
            })
        );
    }, [dispatch]); // eslint-disable-line react-hooks/exhaustive-deps

    // Non-GSPOS roles don't get a client picker — lock onto their own client as
    // soon as the clients list (and therefore the matching client object) is available.
    useEffect(() => {
        if (isGspos || selectedClient || !clients.length) return;
        const ownClientId = localStorage.getItem('clientid') || '';
        const ownClient = clients.find((c) => String(c.client_id) === String(ownClientId));
        if (ownClient) dispatch(setSelectedClient(ownClient));
    }, [isGspos, clients, selectedClient, dispatch]);

    const handleReset = () => {
        dispatch(resetFilters());
        dispatch(
            fetchCompanyData({
                rolename: localStorage.getItem('role') || '',
                clientname: localStorage.getItem('clientid') || ''
            })
        );
    };

    return (
        <>
            <div className="mb-4">
                <h2 className="text-3xl font-bold mb-2" style={{ color: 'var(--primary-color)' }}>
                    Company Directory
                </h2>
                <p className="text-color-secondary">View and manage company records filtered by client, branch and platform</p>
            </div>

            <Card className="mb-4 bill-reports-filter-card">
                <div className="flex flex-wrap gap-4 align-items-end bill-reports-filter-row">
                    {isGspos && (
                        <div className="flex flex-column" style={{ flex: '1 1 200px', minWidth: '200px' }}>
                            <label className="mb-2 font-medium text-sm">Client</label>
                            <Dropdown
                                value={selectedClient}
                                options={clients}
                                onChange={(e) => dispatch(setSelectedClient(e.value))}
                                optionLabel="client_name"
                                placeholder="Select Client"
                                className="w-full"
                                filter
                                showClear
                            />
                        </div>
                    )}

                    <div className="flex flex-column" style={{ flex: '1 1 200px', minWidth: '200px' }}>
                        <label className="mb-2 font-medium text-sm">Branch</label>
                        <Dropdown
                            value={selectedBranch}
                            options={filteredBranches}
                            onChange={(e) => dispatch(setSelectedBranch(e.value))}
                            optionLabel="branch_name"
                            placeholder={selectedClient ? 'Select Branch' : 'Select Client First'}
                            className="w-full"
                            filter
                            showClear
                            disabled={!selectedClient}
                        />
                    </div>

                    <div className="flex flex-column" style={{ flex: '1 1 200px', minWidth: '200px' }}>
                        <label className="mb-2 font-medium text-sm">Platform</label>
                        <Dropdown
                            value={selectedPlatform}
                            options={filteredPlatforms}
                            onChange={(e) => dispatch(setSelectedPlatform(e.value))}
                            optionLabel="platform_name"
                            placeholder="Select Platform"
                            className="w-full"
                            filter
                            showClear
                        />
                    </div>

                    <div className="flex gap-2" style={{ flex: '0 0 auto' }}>
                        <Button label="Reset" icon="pi pi-refresh" className="p-button-secondary" onClick={handleReset} disabled={loading} />
                    </div>
                </div>
            </Card>
        </>
    );
};

export default CompanyHeader;
